import MyDepartmentList from "./myDepartmentList";
export default MyDepartmentList;